import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";
import type { FormInstance } from "element-plus";
import ReportService from "@/projects/tenant/modules/report/services/ReportService";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTypes',
  setup(__props, { expose: __expose }) {

const isLoading = ref(false);
const dialogRef = ref(false);
const ruleFormRef = ref<FormInstance>();
const query = ref<Array<any>>([]);
const formData = ref<any>({
  title: "",
  key: "",
  type: "",
  query: {
    date: null,
    group: null,
  },
  status: 0,
});

const rules = {
  title: [{ required: true, message: "Please input title", trigger: "blur" }],
  key: [{ required: true, message: "Please input key", trigger: "blur" }],
};
const show = () => {
  dialogRef.value = true;
};

const handleQuery = async () => {
  if (!query.value.includes("date")) {
    delete formData.value.query.date;
  } else {
    formData.value.query.date = null;
  }
  if (!query.value.includes("group")) {
    delete formData.value.query.group;
  } else {
    formData.value.query.group = null;
  }
  if (!query.value.includes("from")) {
    delete formData.value.query.from;
  } else {
    formData.value.query.from = null;
  }
  if (!query.value.includes("to")) {
    delete formData.value.query.to;
  } else {
    formData.value.query.to = null;
  }
  if (!query.value.includes("uid")) {
    delete formData.value.query.uid;
  } else {
    formData.value.query.uid = null;
  }
  if (!query.value.includes("accountNumber")) {
    delete formData.value.query.accountNumber;
  } else {
    formData.value.query.accountNumber = null;
  }
  if (!query.value.includes("month")) {
    delete formData.value.query.month;
  } else {
    formData.value.query.month = null;
  }
  if (!query.value.includes("year")) {
    delete formData.value.query.year;
  } else {
    formData.value.query.year = null;
  }
};

const submitForm = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;

  try {
    isLoading.value = true;
    await handleQuery();
    await ReportService.createReportType(formData.value);
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogRef).value = $event)),
    title: "Create Report Types",
    width: "500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Confirm ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
                placeholder: "Title",
                disabled: isLoading.value,
                clearable: ""
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.key,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.key) = $event)),
                placeholder: "Key",
                clearable: "",
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.type) = $event)),
                placeholder: "Type",
                disabled: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: "pdf",
                    label: "PDF"
                  }),
                  _createVNode(_component_el_option, {
                    value: "csv",
                    label: "CSV"
                  }),
                  _createVNode(_component_el_option, {
                    value: "excel",
                    label: "Excel"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: query.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((query).value = $event)),
                disabled: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, { label: "month" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Month")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "year" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Year")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "date" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Date")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "from" }, {
                    default: _withCtx(() => [
                      _createTextVNode("From")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "to" }, {
                    default: _withCtx(() => [
                      _createTextVNode("To")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "group" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Group")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "uid" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Uid")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "accountNumber" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Account Number")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})